import { render, staticRenderFns } from "./PersonSummary.vue?vue&type=template&id=d4da9b96&scoped=true&"
import script from "./PersonSummary.vue?vue&type=script&lang=js&"
export * from "./PersonSummary.vue?vue&type=script&lang=js&"
import style0 from "./PersonSummary.vue?vue&type=style&index=0&id=d4da9b96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4da9b96",
  null
  
)

export default component.exports